import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MultiLanguageSettings = lazy(() =>
  import("@scenes/MultiLanguageSettings").then((module) => ({
    default: module.default.MultiLanguageSettings,
  }))
);

export const multiLanguageSupportNRO: NavigationRoutingObject = {
  Component: MultiLanguageSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("multi-language-locale-settings-pill-menu-option", "Localization Settings"),
  pageNameForTracking: () => "Localization Settings",
  tag: "new",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("multi-language-settings-alt-keyword-1", "Locales")],
    },
    {
      keywords: [
        t("multi-language-support-nro-additional-keyword-multi-language-support", "Multi-Language Support"),
        t("multi-language-support-nro-additional-keyword-support", "Support"),
      ],
      description: t(
        "multi-language-support-nro-additional-description-previously-multi-language-support",
        "Previously Multi-Language Support"
      ),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
